module.exports = __webpack_public_path__ + "img/Hassle-free-2-1536x970.jpg.44577e82.webp";